import{AlgoliaMatchLevelEnum as o,ALGOLIA_MATCH_LEVEL_PRIORITY as t}from"../consts/match-level.js";const e=e=>{const n=e??o.None;return t[n]};export{e as getValueMatchLevelPriority};
